<script setup lang="ts">
import Dialog from "primevue/dialog";
import { viewDetailDialogPt } from "./styles";
import type { ViewDetailsEmits, ViewDetailsProps } from "./types";
import { formatTimestamp } from "./utils";

// ── Props & Emits ────────────────────────────────────────────────────────────

const props = withDefaults(defineProps<ViewDetailsProps>(), {
  userName: "",
  interactions: () => [],
});

const emit = defineEmits<ViewDetailsEmits>();
</script>

<template>
  <Dialog
    :visible="props.visible"
    :pt="viewDetailDialogPt"
    :draggable="false"
    :dismissable-mask="true"
    modal
    close-on-escape
    @update:visible="emit('update:visible', $event)"

  >
    <template #header>
      <span>{{ props.userName }}</span>
    </template>

    <template #closeicon>
      <span class="text-base leading-none">✕</span>
    </template>

    <div class="flex flex-col gap-4">
      <template v-for="interaction in props.interactions" :key="interaction.id">

        <!-- ── User message (right) ── -->
        <div v-if="interaction.user_text" class="flex flex-col items-end gap-1.5">
          <div class="flex items-start gap-2">
            <p class="bg-teal-50 rounded-2xl rounded-tr-none px-4 py-2.5 text-sm text-gray-800 max-w-sm leading-relaxed">
              {{ interaction.user_text }}
            </p>
            <div class="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0 mt-0.5">
              <span class="material-symbols-outlined text-sm text-gray-500 leading-none">person</span>
            </div>
          </div>
          <div class="flex items-center gap-2 text-xs text-gray-500 mr-10">
            <span class="font-semibold text-gray-700">{{ props.userName }}</span>
            <span>{{ formatTimestamp(interaction.chat_interaction_datetime) }}</span>
          </div>
        </div>

        <!-- ── Agent message (left) ── -->
        <div v-if="interaction.agent_response" class="flex flex-col gap-2">
          <div class="flex items-center gap-2 text-xs text-gray-500">
            <span class="font-semibold text-gray-700 text-sm">Atlo</span>
            <span>{{ formatTimestamp(interaction.chat_interaction_datetime) }}</span>
          </div>
          <div class="flex items-start gap-2">
            <div class="w-8 h-8 rounded-full bg-violet-100 flex items-center justify-center flex-shrink-0 mt-0.5">
              <span class="material-symbols-outlined text-sm text-violet-500 leading-none">auto_awesome</span>
            </div>
            <p class="bg-violet-100 rounded-2xl rounded-tl-none px-4 py-2.5 text-sm text-gray-800 max-w-sm leading-relaxed">
              {{ interaction.agent_response }}
            </p>
          </div>
        </div>

      </template>

      <!-- Empty state -->
      <p v-if="!props.interactions.length" class="text-sm text-gray-500 text-center py-6">
        No conversation history available.
      </p>
    </div>
  </Dialog>
</template>
